export const Navbar = () => {

	return <div class="topnavtk2" id="myTopnavtk2">
		<a data-event-category="Navbar" data-event-action="Link Click" data-event-label="Leave Event" href="https://loblaw.tkeventsregistration.com/iwd2022" id="LeaveEvent" class="activetk2">Leave Event</a>
		<a onclick={window.openSupport} title="Help / Aide">Help / Aide</a>

		<div class="dropdowntk2">
			<button class="dropbtntk2">Venue / Lieu
				<i class="fa fa-caret-down" />
			</button>
			<div class="dropdown-contenttk2">
				<a data-event-category="Navbar" data-event-action="Link Click" data-event-label="Lobby" href="/lobby" title="Lobby / Vestibule">Lobby / Vestibule</a>
				<a data-event-category="Navbar" data-event-action="Link Click" data-event-label="Gallery" href="/gallery" title="Gallery / La galerie">Gallery / La galerie</a>
			</div>
		</div>
		<div class="dropdowntk2">
			<button class="dropbtntk2">Agenda
				<i class="fa fa-caret-down" />
			</button>
			<div class="dropdown-contenttk2">
				<a href="https://loblaw.tkeventsregistration.com/iwd2022/Full-Agenda" data-event-category="Navbar" data-event-action="Link Click" data-event-label="Agenda" title="Agenda / Ordre du jour">Agenda / Ordre du jour</a>
				<a href="https://loblaw.tkeventsregistration.com/IWD2022/Personal-Agenda" data-event-category="Navbar" data-event-action="Link Click" data-event-label="Personal Agenda" title="Personal Agenda / Ordre du jour personnel">Personal Agenda / Ordre du jour personnel</a>
			</div>
		</div>
	</div>
}

